import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class TopicSharingIcon extends BaseIcon {
    getChildren = () => [
        <g fill={this.getColor()}>
            <rect width="4.2" height="4.2" x="17.9" y="2.9"
                  transform="matrix(0.7071 -0.7071 0.7071 0.7071 2.3223 15.6066)"/>
            <rect width="7.1" height="7.1" x="11.5" y="8.5"
                  transform="matrix(0.7071 -0.7071 0.7071 0.7071 -4.0919 14.1213)"/>
            <rect width="4.2" height="4.2" x="10.9" y="0.9"
                  transform="matrix(0.7071 -0.7071 0.7071 0.7071 1.6863 10.0711)"/>
            <path d="M22.2,18.1c-2.5,0-6.4,1.8-7.4,2.2c-1.9,0.5-3.1,0.5-4.5,0.6C9.3,21,8.8,20,9.4,20c1.1-0.1,2.2-0.2,3.3-0.4
		c0.2,0,0.2-0.3,0.2-0.3c-0.1-0.5-0.4-1-0.9-1.2c-1.2-0.7-4-1-5-1c-0.2,0-1,0-1,0l0,0v7h4c3.2,0,4.3-0.3,6-1c1.5-0.7,5-2.6,5-2.6
		S24.6,18.1,22.2,18.1z"/>
            <rect width="5.7" height="5.7" x="3.2" y="3.2" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -2.4853 6)"/>
            <polygon points="5,16 2,16 2,24 5,24"/>
        </g>
    ]
    getViewBox = () => '0 0 24 24'
}
